import reducer from "./reducer";
export { default as DelegateAttentions } from "./components/index";
export { default as delegateAttentionsReducerName } from "./constants";
export default reducer;
